import { Component, ElementRef, ViewChild, inject, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { RejectExsepComponent } from '../../components/reject-exsep/reject-exsep.component';
import { exsepProfile } from 'src/app/models/enums/exsep-profile.enum';
import { ExsepService } from '../../services/exsep/exsep.service';
import { handlePaginationChangeUtil } from 'src/app/core/services/uitls/navigation.utils';
import { ActivatedRoute, Router } from '@angular/router';
import { FilterUtilService } from 'src/app/core/services/uitls/filter-utilizer/filter-util.service';
import { FiltersService } from 'src/app/core/services/filters/filters.service';
import { AlertBoxComponent } from 'src/app/shared/components/alert-box/alert-box.component';
import { SummerNoteConfig } from 'src/app/common/summernote-config';
import { DomSanitizer } from '@angular/platform-browser';
import { Images } from 'src/app/shared/global/image-constants';

interface ExpertProfileConfig {
  expertType: 'sopra' | 'ayen';
  pageTitle: string;
  filterPage: string;
  statusLabel: string;
  rejectDialogTitle: string;
}

@Component({
    selector: 'expert-profile',
    templateUrl: './expert-profile.component.html',
    styleUrl: './expert-profile.component.scss',
    standalone: false
})
export class ExpertProfileComponent {
  inspectors: any;
  config: {
    id: string;
    itemsPerPage: number;
    currentPage: any;
    totalItems: any;
  };
  page: number = 1;
  totalRecords: number = 0;
  currentItemsPerPage: number = 0;
  exsepProfile: any = exsepProfile;
  pageTitle: string = '';
  spinner: boolean = true;
  filterData!: any;
  filterDataInit = {};
  filterParamsUrl: Record<string, string | string[]> = {};
  filterPage: string = '';
  spinnerKey: string = 'spinner';
  page_size: number = 20;
  searchValue!: string;
  inspectorShareTypes: any[] = [];
  saveDialogRef!: MatDialogRef<AlertBoxComponent>;
  displayedColumns: string[] = [];
  @ViewChild('goUp', { static: true }) contentPage!: ElementRef;
  summerNoteConfig = SummerNoteConfig.MAIN_CONFIG;
  imgDefault: string = Images.DEFAULT_SORT;
  imgASC: string = Images.ASC_SORT;
  imgDesc: string = Images.DESC_SORT;
  orderingState: Record<string, boolean | null> = { profile_views: null };
  ordering: string[] = [];

  // Configuration from route data
  expertConfig!: ExpertProfileConfig;
  private destroyRef = inject(DestroyRef);

  constructor(
    private dialog: MatDialog,
    private expertService: ExsepService,
    private router: Router,
    private route: ActivatedRoute,
    private filter: FiltersService,
    private filterUtil: FilterUtilService,
    private sanitizer: DomSanitizer
  ) {
    this.config = {
      id: 'myPagination',
      itemsPerPage: 20,
      currentPage: this.page,
      totalItems: this.totalRecords,
    };
  }

  ngOnInit() {
    // Get configuration from route data
    this.expertConfig = this.route.snapshot.data['config'];
    this.pageTitle = this.expertConfig.pageTitle;
    this.filterPage = this.expertConfig.filterPage;

    // Show share_type column only on ayen profile page
    this.displayedColumns = [
      'name',
      'internal_id',
      'registration_as',
      'profile_views',
      'utm_source',
      'email',
      'status',
      'notes',
      ...(this.expertConfig.expertType === 'sopra' ? ['share_type'] : []),
      'created_at',
      'updated_at',
      'actions',
    ];

    this.route.queryParams.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((params) => {
      if (params.page && params.page_size) {
        this.page = Number(params.page);
        this.page_size = Number(params.page_size);
        this.config.currentPage = Number(params.page);
        this.config.itemsPerPage = Number(params.page_size);
      } else {
        this.router.navigate([], {
          queryParams: { page: 1, page_size: 20 },
          queryParamsHandling: 'merge',
        });
      }

      this.setFilterParamsValues(params);
    });
    this.getFilterData();
    this.applyfilterSettings();
    this.getInspectorShareTypes();
  }

  getInspectorShareTypes() {
    this.expertService.getInspectorShareTypes().subscribe((data) => {
      this.inspectorShareTypes = data;
    });
  }

  onRoleChange(row: any, newValue: string) {
    const data = {
      profile_id: row.profile_id,
      inspector_share_type: newValue ?? null,
    };
    this.expertService.updateExsepStatusProfile(data).subscribe(
      (res) => {
        row.inspector_share_type.id = newValue;
      },
      (error: any) => {
        this.showAlertBox((Object.values(error.error)[0] as string).toString());
      }
    );
  }

  setFilterParamsValues(params: any) {
    this.filterUtil.clearfilterParams(this.filterParamsUrl);
    this.filterUtil.clearfilterParams(this.filterDataInit);
    if (Object.keys(params).length > 0) {
      this.searchValue = params['query'] ? params['query'] : '';
      this.filterParamsUrl = { ...params };
      this.filterDataInit = { ...params };
    }
    if (this.ordering.length) {
      this.filterParamsUrl['ordering'] = this.ordering;
    } else {
      delete this.filterParamsUrl['ordering'];
    }
  }

  applyfilterSettings() {
    this.filterUtil.getSavedFilters(this, this.filterPage);
    this.filter.changeSelectedFilter(this.filterDataInit);
    this.filterUtil.applySelectedFilter(
      this,
      this.getInspectorsByPage,
      this.spinnerKey
    );
  }

  getFilterData() {
    let params = {
      filter_page: this.filterPage,
    };
    this.filter.getFiltersData(params).subscribe(
      (data) => {
        this.filterData = data;
      },
      (error) => {
        try {
        } catch {}
      }
    );
  }

  acceptRequest(req: any) {
    let data = {
      status: this.exsepProfile.Accepted,
    };
    const updateMethod = this.expertConfig.expertType === 'sopra' 
      ? this.expertService.updateSopraStatusProfile(data, req.id)
      : this.expertService.updateAyenStatusProfile(data, req.id);

    updateMethod.subscribe(
      (data) => {
        req.status.id = this.exsepProfile.Accepted;
        req.status.name = 'مقبول';
      },
      (error: any) => {
        this.showAlertBox((Object.values(error.error)[0] as string).toString());
      }
    );
  }

  rejectRequest(req: any) {
    const dialogRef = this.dialog.open(RejectExsepComponent, {
      width: '600px',
      data: {
        note: req.note,
        title: this.expertConfig.rejectDialogTitle,
        placeholder: 'أكتب سبب الرفض...',
        buttonTxt: 'مرفوض',
        buttonColor: 'delete',
      },
    });
    dialogRef.afterClosed().subscribe((note) => {
      if (note) {
        let data = {
          status: 'REJECTED',
          notes: note,
        };

        const updateMethod = this.expertConfig.expertType === 'sopra' 
          ? this.expertService.updateSopraStatusProfile(data, req.id)
          : this.expertService.updateAyenStatusProfile(data, req.id);

        updateMethod.subscribe(
          (data) => {
            req.status.id = 'REJECTED';
            req.status.name = 'مرفوض';
            req.notes = note;
          },
          (error: any) => {
            this.showAlertBox((Object.values(error.error)[0] as string).toString());
          }
        );
      }
    });
  }

  RequireData(req: any) {
    const dialogRef = this.dialog.open(RejectExsepComponent, {
      width: '600px',
      data: {
        notes: req.note,
        title: 'وضح البيانات أو المعلومات الناقصة فى هذا الطلب',
        placeholder: 'اكتب المعلومات الناقصة',
        buttonTxt: 'إرسال الملاحظة',
        buttonColor: 'yellow',
      },
    });
    dialogRef.afterClosed().subscribe((note) => {
      if (note) {
        let data = {
          status: 'REVISION_NEEDED',
          notes: note,
        };

        const updateMethod = this.expertConfig.expertType === 'sopra' 
          ? this.expertService.updateSopraStatusProfile(data, req.id)
          : this.expertService.updateAyenStatusProfile(data, req.id);

        updateMethod.subscribe(
          (data) => {
            req.status.id = 'REVISION_NEEDED';
            req.status.name = 'تعديل مطلوب';
            req.notes = note;
          },
          (error: any) => {
            this.showAlertBox((Object.values(error.error)[0] as string).toString());
          }
        );
      }
    });
  }

  showAlertBox(message: string) {
    this.saveDialogRef = this.dialog.open(AlertBoxComponent, {
      data: {
        imgSuccess: false,
        message: message,
        button: 'تم',
      },
    });
  }

  getInspectorsByPage() {
    let params = { ...this.filterParamsUrl };
    params = this.setParams(params);
    
    const fetchMethod = this.expertConfig.expertType === 'sopra' 
      ? this.expertService.getSopraProfilesByPage(params)
      : this.expertService.getAyenProfilesByPage(params);

    fetchMethod.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (data) => {
        this.setPaginationConfig(data);
        this.inspectors = data.results;
        this.spinner = false;
        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: this.filterParamsUrl,
          queryParamsHandling: '',
        });
      },
      (error: any) => {
        this.spinner = false;
        console.error('Error fetching inspectors:', error);
      }
    );
  }

  setPaginationConfig(data: any) {
    this.page = this.config.currentPage;
    this.config['totalItems'] = data.count;
    this.currentItemsPerPage = data.results.length;
  }

  setParams(params: any) {
    if (this.searchValue) {
      params['query'] = this.searchValue;
    }

    params['page'] = this.config.currentPage;
    params['page_size'] = this.config.itemsPerPage;
    return params;
  }

  getSortImg(colName: string) {
    switch (this.orderingState[colName]) {
      case false: return this.imgASC;
      case true: return this.imgDesc;
      default: return this.imgDefault;
    }
  }

  toggleSort(colName: string) {
    this.ordering = [];
    switch (this.orderingState[colName]) {
      case null:
        this.orderingState[colName] = false;
        break;

      case false:
        this.orderingState[colName] = true;
        break;

      case true:
        this.orderingState[colName] = null;
        break;
    }
    for (const [key, value] of Object.entries(this.orderingState)) {
      switch (value) {
        case false:
          this.ordering.push(key);
          break;
        case true:
          this.ordering.push('-' + key);
          break;
      }
    }

    if (this.ordering.length) {
      this.filterParamsUrl['ordering'] = this.ordering;
    } else {
      delete this.filterParamsUrl['ordering'];
    }

    this.config.currentPage = 1;
    this.getInspectorsByPage();
  }

  quickSearch(event: any) {
    this.searchValue = event;
    this.spinner = true;
    this.config.currentPage = 1;
    this.config.itemsPerPage = 20;
    this.getInspectorsByPage();
  }

  filterFormValues(event: any) {
    this.filterParamsUrl = event.filterParamsUrl;
    if (this.ordering.length) {
      this.filterParamsUrl['ordering'] = this.ordering;
    } else {
      delete this.filterParamsUrl['ordering'];
    }
    this.spinner = true;
    this.config.currentPage = 1;
    this.config.itemsPerPage = 20;
    this.getInspectorsByPage();
  }

  changeToSpecific(event: any) {
    this.pageChanged(event);
  }

  pageChanged(event: any) {
    handlePaginationChangeUtil(
      this.contentPage,
      (value: boolean) => (this.spinner = value),
      this.router,
      'page',
      event
    );
    this.config.currentPage = event;
    this.getInspectorsByPage();
  }

  pageSizeChanged(event: any) {
    handlePaginationChangeUtil(
      this.contentPage,
      (value: boolean) => (this.spinner = value),
      this.router,
      'page_size',
      event
    );
    this.config.itemsPerPage = event;
    this.getInspectorsByPage();
  }

  goToProfile(id: number) {
    this.router.navigateByUrl(`/pages/inspectors/inspector-profile/${id}`);
  }

  ngOnDestroy() {
    this.filter.changeSelectedFilter({});
  }

  getDecodedNotes(notes: string) {
    return this.sanitizer.bypassSecurityTrustHtml(notes);
  }
}
